import { vehiclesModel } from "@/shared/vehicles/vehicles.model";
import {
    CompanyDto,
    EnumCompanyStatus,
    EnumUserRole,
} from "@/shared/api-contract/api-contract";
import { computed, shallowRef, watch } from "vue";
import { sessionModel } from "@/shared/state/session.model";
import { currentCompanyModel } from "@/shared/state/current-company.model";
import { setup } from "vue-class-component";
import { JWTTokenPayloadUser } from "@/shared/models/types/JWTTokenPayload";

export class AppCompanyStatusDialogModel {
    showCompanyStatusModal = shallowRef<
        | false
        | "welcome"
        | "default"
        | "comingSoon"
        | "buy"
        | "add-to-cart"
        | "order-approve"
        | "order-decline"
    >(false);

    show = (
        type:
            | "welcome"
            | "default"
            | "comingSoon"
            | "buy"
            | "add-to-cart"
            | "order-approve"
            | "order-decline" = "default",
    ): boolean => {
        switch (type) {
            case "buy":
            case "add-to-cart":
                if (
                    !sessionModel.JWTUserDto.value ||
                    !currentCompanyModel.companyDto.value ||
                    sessionModel.JWTUserDto.value?.id_role < EnumUserRole.PURCHASOR ||
                    currentCompanyModel.companyDto?.value.status?.id !==
                        EnumCompanyStatus.APPROVED
                ) {
                    this.showCompanyStatusModal.value = "buy";
                    return true;
                } else {
                    return false;
                }
            case "welcome":
            case "default":
            case "comingSoon":
            case "order-approve":
            case "order-decline":
            default:
                return false;
        }
    };

    isLimitedAdmin = computed(() => {
        return false; // TODO: what in the world is a limited admin ???
    });

    isAwaitingAccountConfirmation = computed(() => {
        return false;
        // return currentUserModel.userDto.value?.role.id === EnumUserRole.DEACTIVATED;
    });

    constructor() {
        watch(
            () => ({
                isCompanyInfoFilled: Boolean(currentCompanyModel.companyDto.value?.id),
                isDefaultFiltersLoaded: vehiclesModel.isDefaultFiltersLoaded.value,
                viewDefaultFilters: vehiclesModel.viewDefaultFilters.value,
                accessToken: sessionModel.sessionDto.value?.token,
                isCompanyApproved:
                    currentCompanyModel.companyDto?.value?.status?.id ===
                    EnumCompanyStatus.APPROVED,
            }),
            ({
                isCompanyInfoFilled,
                isDefaultFiltersLoaded,
                viewDefaultFilters,
                accessToken,
                isCompanyApproved,
            }) => {
                if (
                    !accessToken ||
                    !isDefaultFiltersLoaded ||
                    viewDefaultFilters ||
                    isCompanyApproved
                ) {
                    return;
                }

                const sessKey = `company_status_dialog(${
                    isCompanyApproved || 0
                })_was_displayed`;

                const companyStatusDialogWasDisplayed = sessionStorage.getItem(sessKey);

                if (
                    companyStatusDialogWasDisplayed &&
                    JSON.parse(companyStatusDialogWasDisplayed)
                ) {
                    return;
                }

                this.showCompanyStatusModal.value = isCompanyInfoFilled
                    ? false
                    : "welcome";

                sessionStorage.setItem(sessKey, JSON.stringify(true));
            },
            { immediate: true },
        );
    }
}

export const appCompanyStatusDialogModel = new AppCompanyStatusDialogModel();
